import ShelfTabs from './ShelfTabs'

export default ShelfTabs
// eslint-disable-next-line import/export
export * from './ShelfTabs'
